  <template>
    <div class="flex flex-col p-6 ml-4 lg:ml-64">
      <h1 class="text-3xl font-bold mb-4 text-center">Gerenciamento de Funcionários da {{ NomeDaEmpresa }}</h1>


      <!-- Campo de busca -->
      <div id="search-container" class="mb-4 flex items-center space-x-4">
        <input type="text" v-model="searchQuery" class="p-2 border border-gray-300 rounded"
          placeholder="Pesquisar (ID ou Nome )..." />
        <button class="btn-primary px-4 py-2 bg-blue-500 text-white rounded" @click="loadEmployees">Buscar</button>
      </div>

      <!-- Botão Adicionar Funcionário -->
      <button class="btn-primary px-4 py-2 bg-blue-500 text-white rounded mb-4" @click="openModal">Adicionar
        Funcionário</button>

      <!-- Tabela de listagem dos Funcionários -->
      <table id="controls-table" class="min-w-full table-auto border-collapse">
        <thead>
          <tr>
            <th class="border px-4 py-2">ID</th>
            <th class="border px-4 py-2">Nome do Funcionário</th>
            <th class="border px-4 py-2">Cargo</th>
            <th class="border px-4 py-2">Tempo no Cargo</th>
            <th class="border px-4 py-2">Tempo de Empresa</th>
            <th class="border px-4 py-2">Email</th>
            <th class="border px-4 py-2">Telefone</th>
            <th class="border px-4 py-2">Gestor Responsável </th>
            <th class="border px-4 py-2">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(employee, index) in filteredEmployees" :key="employee._id">
            <td class="border px-4 py-2">{{ generateId(index) }}</td>
            <td class="border px-4 py-2 truncate max-16 max-w-[16rem]">{{ employee.NomeFuncionario }}</td>
            <td class="border px-4 py-2">{{ employee.Cargo }}</td>
            <td class="border px-4 py-2">{{ employee.TempoCargo }}</td>
            <td class="border px-4 py-2">{{ employee.TempoEmpresa }}</td>
            <td class="border px-4 py-2 truncate max-16 max-w-[16rem]">{{ employee.Email }}</td>
            <td class="border px-4 py-2">{{ employee.Telefone }}</td>
            <td class="border px-4 py-2">{{ employee.GestorResponsavel }}</td>
            <td class="border px-4 py-2">
              <button class="px-2 py-1 rounded text-xs text-black" @click="handleEdit(employee)">✏️ Editar</button>
              <button class="px-2 py-1 rounded text-xs text-black" @click="confirmarRemocao(employee._id)">🗑️
                Remover</button>
              <button class="px-2 py-1 rounded text-xs text-black" @click="handleAssign(employee)">✅ Atribuir</button>

            </td>
          </tr>
        </tbody>
      </table>

      <!-- Modal de Atribuição de Questões -->
      <div v-if="mostrarAssignModal"
        class="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center">
        <div class="modal bg-white p-6 rounded shadow-lg w-full  h-full relative overflow-auto">
          <button class="px-4 py-2 bg-red-500 rounded hover:bg-amber-800" @click="mostrarAssignModal = false">
            Fechar</button>

          <AssignQuestionManagement :FuncionarioID="assignData.FuncionarioID"
            :NomeFuncionario="assignData.NomeFuncionario" :EmpresaID="formData.EmpresaID"
            :NomeDaEmpresa="NomeDaEmpresa" />
        </div>
      </div>
      <!-- Modal de Cadastro/Edição -->
      <div v-if="modalAberto"
        class="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center">
        <div class="modal bg-white p-6 rounded shadow-lg w-[100%] max-w-4xl h-[90%] relative overflow-auto">
          <button class="px-4 py-2 bg-red-500 rounded hover:bg-amber-800" @click="closedModal">Fechar</button>
          <h2 class="text-2xl font-semibold mb-4">{{ isEditing ? 'Editar Funcionário' : 'Novo Funcionário' }}</h2>
          <h1>{{ NomeDaEmpresa }}</h1>
          <form @submit.prevent="handleSubmit">



            <label class="block text-sm font-medium">Nome do Funcionário</label>
            <textarea type="text" v-model="formData.NomeFuncionario"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" required :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="adjustHeight($event)">
                      </textarea>

            <label class="block text-sm font-medium">Cargo</label>
            <textarea type="text" v-model="formData.Cargo"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" required :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="adjustHeight($event)">
                      </textarea>

            <label class="block text-sm font-medium">Tempo no Cargo</label>
            <textarea type="text" v-model="formData.TempoCargo"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" required :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="adjustHeight($event)">
                      </textarea>

            <label class="block text-sm font-medium">Tempo na Empresa</label>
            <textarea type="text" v-model="formData.TempoEmpresa"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" required :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="adjustHeight($event)">
                      </textarea>

            <label class="block text-sm font-medium">Email</label>
            <input type="Email" v-model="formData.Email"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" required :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="adjustHeight($event)">
            </input>

            <label class="block text-sm font-medium">Telefone</label>
            <textarea type="text" v-model="formData.Telefone"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="handlePhoneInput($event)">
                      </textarea>

            <label class="block text-sm font-medium">Gestor Responsável</label>
            <textarea type="text" v-model="formData.GestorResponsavel"
              class="w-full p-2 border border-gray-300 rounded mb-4 resize-none" :style="{
                minWidth: '750px',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                height: 'auto'
              }" rows="1" @input="adjustHeight($event)">
                      </textarea>
            <div class="modal-footer flex justify-end mt-4">
              <button type="submit" class="btn-success bg-blue-500 text-white py-2 px-4 rounded">Salvar</button>
            </div>
          </form>

        </div>
      </div>
    </div>
  </template>

<script>
import AssignQuestionManagement from '@/components/dashboard/question/AssignQuestionMagement.vue';
import { createEmployee, deleteEmployee, getEmployeesByEnterpriseId, updateEmployee } from '@/services/company/api.employees';
export default {
  props: {
    EmpresaID: {
      type: String,
      required: true
    },
    NomeDaEmpresa: {
      type: String,
      required: true
    }
  },
  components: {
    AssignQuestionManagement
  },

  data() {
    return {
      mostrarAssignModal: false,
      assignData: {
        FuncionarioID: '',
        NomeFuncionario: ''
      },

      employees: [],
      formData: {
        EmpresaID: this.EmpresaID,
        NomeDaEmpresa: this.NomeDaEmpresa,

        Categoria: '',
        NomeFuncionario: '',
        Cargo: '',
        Email: '',
        Telefone: '',
        TempoEmpresa: '',
        TempoCargo: '',
        GestorResponsavel: '',
      },
      isEditing: false,
      modalAberto: false,
      searchQuery: '',
    };
  },
  computed: {
    filteredEmployees() {
      return this.employees.filter(employee => {
        if (!employee) return false;
        const query = this.searchQuery?.toLowerCase() || "";

        return (
          employee.FuncionarioID?.toString().includes(query) ||
          employee.NomeFuncionario?.toLowerCase().includes(query) ||
          employee.Categoria?.toLowerCase().includes(query) ||
          employee.Cargo?.toLowerCase().includes(query)
        );
      });
    }
  },
  methods: {
    handleAssign(employee) {
      this.assignData.FuncionarioID = employee._id;
      this.assignData.NomeFuncionario = employee.NomeFuncionario;
      this.mostrarAssignModal = true;
    },

    generateId(index) {
      return index + 1;
    },
    handlePhoneInput(event) {
      this.formatPhone(event);
      this.adjustHeight(event);
    },
    async adjustHeight(event) {
      const textarea = event.target;
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    formatPhone(event) {
      let value = event.target.value.replace(/\D/g, "");

      if (value.length > 11) {
        value = value.substring(0, 11);
      }

      if (value.length >= 2) {
        value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
      }
      if (value.length >= 10) {
        value = `${value.substring(0, 10)}-${value.substring(10)}`;
      }

      this.formData.Telefone = value;
    },

    async loadEmployees() {

      try {
        const data = await getEmployeesByEnterpriseId(this.EmpresaID);
        this.employees = data.sort((a, b) => a.FuncionarioID - b.FuncionarioID);
      } catch (error) {
        console.error('Erro ao carregar funcionários:', error);
      }
    },

    openModal() {
      this.modalAberto = true;
      this.isEditing = false;
      this.formData = {
        EmpresaID: this.EmpresaID,
        NomeFuncionario: '',
        Categoria: '',
        Cargo: '',
        Email: '',
        Telefone: '',
        TempoEmpresa: '',
        TempoCargo: '',
        GestorResponsavel: '',
      };
    },

    closedModal() {
      this.modalAberto = false;
    },

    async handleSubmit() {
      try {

        if (this.isEditing) {
          await updateEmployee(this.formData._id, this.formData);
        } else {
          await createEmployee(this.formData);
        }

        await this.loadEmployees();
        this.closedModal();
      } catch (error) {
        console.error('Erro ao salvar funcionário:', error);
      }
    },

    handleEdit(employee) {
      this.formData = { ...employee };
      this.isEditing = true;
      this.modalAberto = true;
    },

    async confirmarRemocao(id) {
      const confirmacao = confirm("Tem certeza que deseja remover este Funcionário?");
      if (confirmacao) {
        try {
          await deleteEmployee(id);
          await this.loadEmployees();
        } catch (error) {
          console.error("Erro ao remover funcionário:", error);
        }
      }
    }
  },
  created() {
    this.loadEmployees();
  },
};

</script>
